import { Box, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  StaffEmployment as StaffEmploymentModel,
  StaffEmploymentEditResource,
  StaffEmploymentViewResource,
} from "generated/openApi";
import { StaffEmploymentPageBody } from "pages/staff/staff-employments/StaffEmploymentPage/StaffEmploymentPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StaffEmployment = (props: {
  employment: StaffEmploymentModel;
  setEmployment: (value: StaffEmploymentModel) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<StaffEmploymentViewResource>({});
  const [editResource, setEditResource] = useState<StaffEmploymentEditResource>({});

  useEffect(() => {
    fetchEditResource();
    fetchViewResource();
  }, []);

  const fetchEditResource = () => {
    ApiService.staffEmployments.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  const fetchViewResource = () => {
    ApiService.staffEmployments.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Card
      header={
        <Stack>
          <Box>Employment</Box>
          <Typography variant="caption">
            An employment is required when creating a staff. You may add more employments after succesfully creating
            this staff.
          </Typography>
        </Stack>
      }
    >
      <StaffEmploymentPageBody
        crudMode="edit"
        employment={props.employment}
        setEmployment={(value) => props.setEmployment(value)}
        viewResource={viewResource}
        editResource={editResource}
        validationErrors={props.validationErrors}
      />
    </Card>
  );
};
